module.exports = __webpack_public_path__ + "static/media/right-white.83f46f03.svg";